<template>
	<div v-if="items">
		<v-container class="help-container">
			<h2>Resources and Help</h2>
			<v-list class="help-link-list" role="list">
				<template v-for="(item, i) in items">
					<v-divider
								v-if="!item"
								:key="`divider-${i}`"
						></v-divider>
					<v-list-item
						:href="item.url" download role="button" v-else-if="item.download" :key="i" tabindex="0" class="resources-help-item"
						>
						<v-list-item-content v-bind:class="[item.text === items[1].text ? 'create-link' : 'help-links']">
								<v-list-item-title v-if="displayAlterText && i === 1" class="wrap-text" v-text="item.alterText"></v-list-item-title>
								<v-list-item-title role="button" v-else class="wrap-text" v-text="item.text"></v-list-item-title>
							</v-list-item-content>
							<v-list-item-icon>
								<v-icon v-if="item.text === items[1].text" color="#A54C1D" v-text="item.icon"></v-icon>
								<v-icon v-else v-text="item.icon"></v-icon>
							</v-list-item-icon>
					</v-list-item>
					<v-list-item
							v-else
							:key="i"
							@click="goTo(item.url)"
							role="link"
							tabindex="0"
							class="resources-help-item"
						>
							<v-list-item-content v-bind:class="[item.text === items[1].text ? 'create-link' : 'help-links']">
								<v-list-item-title v-if="displayAlterText && i === 1" class="wrap-text" v-text="item.alterText"></v-list-item-title>
								<v-list-item-title v-else class="wrap-text" v-text="item.text"></v-list-item-title>
							</v-list-item-content>
							<v-list-item-icon>
								<v-icon v-if="item.text === items[1].text" color="#A54C1D" v-text="item.icon"></v-icon>
								<v-icon v-else v-text="item.icon"></v-icon>
							</v-list-item-icon>
						</v-list-item>
				</template>
			</v-list>
		</v-container>
	</div>
</template>

<script>
export default {
	name: 'Help',
	props: {
		displayAlterText: Boolean,
		draftStudyId: String
	},
	data: () => ({
		items: null
	}),
	created () {
		window.addEventListener('keydown', (e) => {
			this.nextTab(e)
		});
	},
	mounted () {
		this.items = this.$helpLinksConfig;
	},
	methods: {
		goTo (url) {
			if (this.displayAlterText) {
				var id = this.draftStudyId;
				this.$store.commit('setSelectedStudyUuid', { id });
			}

			if (url.includes('http')) {
				window.open(url, '_blank');
			} else {
				this.$router.push(url);
			}
		},
		nextTab (e) {
			var activeEl = document.activeElement
			if (activeEl.classList.contains('resources-help-item')) {
				var universe = activeEl.parentElement.querySelectorAll('.resources-help-item');
				var list = Array.prototype.filter.call(universe, function (item) { return item.tabIndex >= '0' });
				var index = list.indexOf(activeEl);
				var nextEl
				if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
					nextEl = list[index + 1] || list[0];
					nextEl.focus()
				}
				if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
					nextEl = list[index - 1] || list[list.length - 1];
					nextEl.focus()
				}
			}
		}
	},
	computed: {
	}
}
</script>

<style></style>
